import React from 'react';
import { formatCompactNumber } from '../utils/utils.js';
import ItemGrid from './ItemGrid.jsx';

const PlayerRow = ({ player, index, team, isExpanded, hasSpacer, loadingHeroes, setExpandedRows, setHoveredItem }) => {
    const teamClass = team === 'amber' ? 'amber' : 'sapphire';
    const playerSlot = player?.player_slot || player?.slot_position || `empty-${index}`;

    const expandRow = () => {
        if (!player) return;
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            newSet.add(playerSlot);
            return newSet;
        });
    };

    const collapseRow = () => {
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            newSet.delete(playerSlot);
            return newSet;
        });
    };

    return (
        <div
            key={`row-${team}-${index}`}
            className={`overlay-row ${player ? 'active' : 'disabled'} ${teamClass} ${isExpanded ? 'expanded' : ''} ${hasSpacer ? 'has-spacer' : ''}`}
            onMouseLeave={collapseRow}
        >
            <div className="overlay-hero">
                <div
                    className="overlay-hero-img"
                    onMouseEnter={expandRow}
                >
                    {player?.hero_image && (
                        <div
                            className="overlay-hero-img-inner"
                            style={{ backgroundImage: `url(${player.hero_image})` }}
                        />
                    )}
                    {player?.hero_id && !player?.hero_image && loadingHeroes.has(player.hero_id) ? (
                        <div className="loading-indicator">
                            <div className="loading-spinner"></div>
                        </div>
                    ) : null}
                </div>
            </div>

            <div className="overlay-names">
                <div className="overlay-player-name">{player?.steam_name || '-'}</div>
                <div className="overlay-hero-name">{player?.hero_name || '-'}</div>
            </div>

            <div className="overlay-stat overlay-souls">
                <div className="overlay-stat-label">Souls</div>
                <div className="overlay-stat-value">{formatCompactNumber(player?.net_worth || 0)}</div>
            </div>

            <div className="overlay-stat overlay-kda">
                <div className="overlay-stat-label">K</div>
                <div className="overlay-stat-value">{player?.kills ?? 0}</div>
            </div>
            <div className="overlay-stat overlay-kda">
                <div className="overlay-stat-label">D</div>
                <div className="overlay-stat-value">{player?.deaths ?? 0}</div>
            </div>
            <div className="overlay-stat overlay-kda">
                <div className="overlay-stat-label">A</div>
                <div className="overlay-stat-value">{player?.assists ?? 0}</div>
            </div>

            <div className="overlay-stat">
                <div className="overlay-stat-label">Player Dmg</div>
                <div className="overlay-stat-value">{formatCompactNumber(player?.hero_damage || 0)}</div>
            </div>
            <div className="overlay-stat">
                <div className="overlay-stat-label">Obj Dmg</div>
                <div className="overlay-stat-value">{formatCompactNumber(player?.objective_damage || 0)}</div>
            </div>
            <div className="overlay-stat">
                <div className="overlay-stat-label">Healing</div>
                <div className="overlay-stat-value">{formatCompactNumber(player?.hero_healing || player?.self_healing || 0)}</div>
            </div>

            <ItemGrid player={player} setHoveredItem={setHoveredItem} />
        </div>
    );
};

export default PlayerRow;
